import { css } from 'styled-components';

export const spaceProps = ['mt', 'mr', 'mb', 'ml', 'm', 'pt', 'pr', 'pb', 'pl', 'p'];

const getSmallestMediaQueryKey = obj => {
  return Object.keys(obj)
    .sort()
    .reverse()[0];
};

const flexTypes = ['column', 'column-reverse', 'row', 'row-reverse'];
export const flex = ({ flexbox }) => {
  if (!flexbox) return;
  if (typeof flexbox === 'string' && flexTypes.includes(flexbox)) {
    return css`
      display: flex;
      flex-direction: ${flexbox};
    `;
  }
  return css`
    display: flex;
  `;
};

const alignment = (prop, attr, val) => props =>
  props[prop] &&
  css`
    ${attr}: ${val};
  `;

export const responsiveAttr = (propName, attr) => props => {
  const value = props[propName];
  if (typeof value === 'undefined' || value === null) {
    return;
  }

  if (typeof value === 'number' || typeof value === 'string') {
    return css`
      ${attr}: ${inferUnits(value)};
    `;
  }

  if (typeof value === 'object') {
    return css`
      @media (max-width: ${props => props.theme.breakpoints[getSmallestMediaQueryKey(value)]}rem) {
        ${attr}: ${inferUnits(value[getSmallestMediaQueryKey(value)])}${
      typeof value[getSmallestMediaQueryKey(value)] === 'number' ? '' : 'px'
    };
      }

      ${Object.keys(value).map(
        bp => `
        @media (min-width: ${props.theme.breakpoints[bp]}rem) {
          ${attr}: ${inferUnits(value[bp])};
        }
      `
      )};
    `;
  }
};

export const inferUnits = (value, unit = 'rem') => {
  if (typeof value === 'number') {
    return `${value}${unit}`;
  }
  return value;
};

export const spaceOptions = css`
  ${responsiveAttr('m', 'margin')};
  ${responsiveAttr('mt', 'margin-top')};
  ${responsiveAttr('mr', 'margin-right')};
  ${responsiveAttr('mb', 'margin-bottom')};
  ${responsiveAttr('ml', 'margin-left')};
  ${responsiveAttr('p', 'padding')};
  ${responsiveAttr('pt', 'padding-top')};
  ${responsiveAttr('pr', 'padding-right')};
  ${responsiveAttr('pb', 'padding-bottom')};
  ${responsiveAttr('pl', 'padding-left')};
  ${alignment('center', 'text-align', 'center')};
  ${alignment('left', 'text-align', 'left')};
  ${alignment('right', 'text-align', 'right')};
  ${flex};
`;
